import getFromCdn from '@anm/helpers/getFromCdn';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const TermsUseStyle = styled.div`
  margin: 0 auto;
  max-width: 900px;
  width: 100%;
  box-sizing: border-box;
  padding: 40px 20px;
  background-color: #fff;

  * {
    font-weight: 400;
    line-height: 24px;
    font-size: 15px;
  }
  b,
  h1,
  h2,
  h3 {
    font-weight: 700;
  }

  h1,
  h2,
  h3 {
    font-size: 23px;
  }

  p {
    margin-bottom: 25px;
    line-height: 22px;
    b {
      i {
        text-transform: uppercase;
      }
    }
  }
  h1 {
    font-size: 36px;
    line-height: 1;
    text-transform: uppercase;
    text-align: center;

    & + h2 {
      text-align: center;
      margin-top: 12px;
      margin-bottom: 50px;
    }
  }
  h2 {
    margin-top: 50px;
  }
  h3 {
    margin-top: 30px;
  }
  ol {
    padding-left: 20px;
    margin-bottom: 25px;
    li {
      list-style-type: lower-alpha;
      margin-bottom: 10px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
  address {
    font-style: normal;
    a:first-child {
      background: url(${getFromCdn('images/icons/logo_black.svg')}) no-repeat 0
        0 transparent;
      display: inline-block;
      padding: 30px 0 0 5px;
      width: 140px;
      background-size: 145px 35px;
      margin-bottom: 20px;
    }
    p,
    a:last-child {
      padding-left: 20px;
      background: url(${getFromCdn('images/icons/location_black.svg')})
        no-repeat;
      background-position: left 2px;
      background-size: 14px 14px;
      margin-bottom: 10px;
    }
    a:last-child {
      background: url(${getFromCdn('images/icons/mail.svg')}) no-repeat;
      background-position: left center;
      margin-top: 10px;
      background-size: auto 70%;
    }
  }
`;

const MobileLastUpdated = media.tablet`    
    padding: 0 20px;
    box-sizing: border-box;
    padding-bottom: 5vmax;
    margin: 30px auto 0;
    background-color: #fff;
    width: 100%;
`;

export const LastUpdated = styled.div`
  font-weight: 300;
  color: #b3b9c0;
  font-size: 14px;
  text-align: center;
  width: 90%;
  margin: 90px auto 0;

  ${MobileLastUpdated}
`;

export default TermsUseStyle;
